export enum moduleAudiencesNames {
  SET_AUDIENCE_FLOW = "SET_AUDIENCE_FLOW",
  SET_AUDIENCE_ID = "SET_AUDIENCE_ID",
  SET_AUDIENCE_COPY = "SET_AUDIENCE_COPY",
  SET_AUDIENCE_TIP = "SET_AUDIENCE_TIP",
}
